/*跨域地址*/
const dev = process.env.dev

export default {
    /**访问记录 */
    savePv: {
        url: dev + '/noauth/h5/order/visit',
        method: 'post'
    },
    // 新保存渠道浏览记录
    savePvNew: {
        url: dev + '/noauth/h5/order/visit/dac',
        method: 'post'
    },
    //发送验证码
    getSmsCodeActivity: {
        url: dev + '/noauth/h5/order/sms/code',
        method: 'post'
    },
    //滑动验证码
    getGeeCode: {
        url: dev + '/noauth/h5/order/captcha',
        method: 'get'
    },
    //新增活动参与人信息
    addPerson: {
        url: dev + '/noauth/h5/order/commit',
        method: 'post'
    },
    //新落地页的数据提交
    addH5: {
        url: dev + '/noauth/h5/order/commit/new',
        method: 'post'
    },
    //记录数据源
    recordStatistics: {
        url: dev + '/noauth/h5/order/action/add',
        method: 'post'
    },
    //上传用户行为数据_上海微盟
    userAction: {
        url: dev + '/noauth/tencent/user/action',
        method: 'post'
    },
    // 豆盟初步转化
    deepTranslate: {
        url: dev + '/noauth/doumob/deepTranslate',
        method: 'post'
    },
    //上次用户行为By微信公众号
    userActionByWx: {
        url: dev + '/noauth/tencent/user/action/wx',
        method: 'get'
    },
    // 推啊回传用户信息
    tuiaUserInfo: {
        url: dev + '/noauth/tuia',
        method: 'post'
    },
    // 根据客户手机号查询代理人集合信息
    getAgentInfoByPhone: {
        url: dev + '/noauth/h5/order/agents',
        method: 'get'
    },
    //广点通上传用户行为数据_北京亿科
    userActionYk: {
        url: dev + '/noauth/tencent/user/action/qq',
        method: 'get'
    },
    //新微信公众号的数据提交
    addWXMP: {
        url: dev + '/wxmp/order/commit/new',
        method: 'post'
    },
    //新保存渠道浏览记录
    savePvNewByWXMP: {
        url: dev + '/wxmp/order/visit/new',
        method: 'post'
    },
    //百度广告-用户上传数据
    saveBaiduData: {
        url: dev + '/noauth/baidu/convert/data',
        method: 'get'
    },
    //微信投放记录数据源_广点通上传用户行为数据_海南亿科
    saveWechatData: {
        url: dev + '/noauth/wx/action/add',
        method: 'post'
    },
    //微信投放记录数据源_广点通上传用户行为数据_海南亿科2
    saveWechatData2: {
        url: dev + '/noauth/wx/action/add/2',
        method: 'post'
    },
    //根据订单类型查询下单数
    svOrderTypeCount: {
        url: dev + '/noauth/h5/order/count',
        method: 'get'
    },
    //是否显示更换顾问按钮
    changeAgent: {
        url: dev + '/noauth/premium/cal/whether/change/agent',
        method: 'get'
    },
    //点击预约服务顾问
    orderServe: {
        url: dev + '/noauth/premium/cal/match/agent',
        method: 'post'
    },
    //需要微信认证的公众号下单
    orderSvorder: {
        url: dev + '/wxmp/order/commit/new',
        method: 'post'
    },
    //查询服务顾问快保工作室信息
    searchAgentInfo: {
        url: dev + '/noauth/h5/order/agent/studio/info',
        method: 'get'
    },
    //获客赋能-查询素材
    sourceContent: {
        url: dev + '/hkfn/source/content',
        method: 'get'
    },
    // 模板配置信息_旧
    diyInformation: {
        url: dev + '/noauth/hkfn/agent/diy/information',
        method: 'get'
    },
    // 模板配置信息_subId
    newDiyInformation: {
        url: dev + '/noauth/hkfn/agent/diy/information/detail',
        method: 'get'
    },
    // 代理人信息
    diyAgentInfo: {
        url: dev + '/noauth/hkfn/agent/information',
        method: 'get'
    },
    //新落地页的数据提交_subId
    newAddH5: {
        url: dev + '/noauth/h5/order/commit/dac',
        method: 'post'
    },
    //获客赋能-查询素材_subId
    sourceContentNew: {
        url: dev + '/noauth/h5/order/source/content/new',
        method: 'get'
    },
    //上传用户行为数据_云拓
    userActionYt: {
        url: dev + '/noauth/tencent/user/action/yt',
        method: 'post'
    },
    //根据模块id查询公开的模块
    findDiyModules: {
        url: dev + '/noauth/hkfn/find/public/module/id',
        method: 'post'
    }
};



// WEBPACK FOOTER //
// ./src/api/activity.js